import { inject, Injector, runInInjectionContext } from '@angular/core';
import { Routes } from '@angular/router';

function resolvePlatformConnection() {
   const injector = inject(Injector);
   return import('@core/api/signalr.connectionresolver').then((module) =>
      runInInjectionContext(injector, () => inject(module.ConnectionResolver).resolve())
   );
}

export const PUBLIC_ROUTES: Routes = [
{
   path: 'login',
   loadComponent: () => import('../pages/login/login.component').then((m) => m.LoginComponent),
},
//#region #New Register
{
   path: 'signup',
   loadComponent: () =>
      import('../pages/signup/new-company/new-company.component').then(
         (m) => m.NewCompanyComponent,
      ),
},
{
   path: 'signup/success',
   loadComponent: () =>
      import('../pages/signup/new-company/success/success.component').then(
         (m) => m.SuccessComponent,
      ),
},
//#region #Password Reset
{
   path: 'password-reset',
   loadComponent: () =>
      import('../pages/password-reset/password-reset.component').then(
         (m) => m.PasswordResetComponent,
      ),
},
{
   path: 'new-password/:Token',
   loadComponent: () =>
      import('../pages/password-reset/new-password/new-password.component').then(
         (m) => m.NewPasswordComponent,
      ),
},
{
   path: 'signature-invitation/:Id',
   loadComponent: () =>
      import('../pages/signup/signature-invitation/signature-invitation.component').then(
         (m) => m.SignatureInvitationComponent,
      ),
},
{
   path: 'assinatura/convite/:Id',
   loadComponent: () =>
      import('../pages/signup/signature-invitation/signature-invitation.component').then(
         (m) => m.SignatureInvitationComponent,
      ),
},
{
   path: 'recuperacaodesenha',
   loadComponent: () =>
      import('../pages/password-reset/password-reset.component').then(
         (m) => m.PasswordResetComponent,
      ),
},
{
   path: 'novasenha/:Token',
   loadComponent: () =>
      import('../pages/password-reset/new-password/new-password.component').then(
         (m) => m.NewPasswordComponent,
      ),
},
//#region #POS RfId Card
{
   path: 'clientepos/:bindedPosId/:rfId',
   loadComponent: () =>
      import('../pages/pos-components/rfId-value/rfId-value.component').then(
         (m) => m.RfIdValueComponent,
      ),
},
//#region #Waitlist Customer Position
{
   path: 'wait-list/:Id',
   loadComponent: () =>
      import('../pages/relationship/waitlist-customer-position/waitlist-customer-position.component').then(
         (m) => m.WaitlistCustomerPositionComponent,
      ),
},
{
   path: 'filaespera/:Id',
   loadComponent: () =>
      import('../pages/relationship/waitlist-customer-position/waitlist-customer-position.component').then(
         (m) => m.WaitlistCustomerPositionComponent,
      ),
},
//-----------------------------------------------------------------------------------------
//#region #Order Center Pos
{
   path: 'centralpedidospos/:pos/:companyId',
   data: { roles: [], Pos: ':pos', CompanyId: ':CompanyId' },
   loadComponent: () =>
      import('../pages/pos-components/pos-components.component').then(
         (m) => m.PosComponentsComponent,
      ),
   resolve: { connection: resolvePlatformConnection },
},
];
